import { render } from "./Yamaguchi.vue?vue&type=template&id=16d82355"
import script from "./Yamaguchi.vue?vue&type=script&lang=js"
export * from "./Yamaguchi.vue?vue&type=script&lang=js"

import "./Yamaguchi.vue?vue&type=style&index=0&id=16d82355&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__